module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-pulmonology1@2x.5c9a0541.png";